var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMdiAccountAlertOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MDI_account-alert-outline",
    "data-name": "MDI / account-alert-outline",
    transform: "translate(16 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    transform: "translate(-16 -16)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_account-alert-outline",
    "data-name": "Path / account-alert-outline",
    d: "M14,9.333V6h1.333v4H14m0,2.667h1.333V11.333H14M7.333,10c1.78,0,5.333.893,5.333,2.667v2H2v-2C2,10.893,5.553,10,7.333,10m0-6A2.667,2.667,0,1,1,4.667,6.667,2.667,2.667,0,0,1,7.333,4m0,7.267c-1.98,0-4.067.973-4.067,1.4V13.4H11.4v-.733c0-.427-2.087-1.4-4.067-1.4m0-6a1.4,1.4,0,1,0,1.4,1.4,1.4,1.4,0,0,0-1.4-1.4Z",
    transform: "translate(-16.667 -17.333)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiAccountAlertOutline);
export default __webpack_public_path__ + "static/media/MDI - account-alert-outline.2948a13500086941ece18f5b1e168fd2.svg";
export { ForwardRef as ReactComponent };